import React from "react";
import CountUp from "react-countup";
 // External styling (optional)

const AboutCounter = () => {
  // Counter data for modularity
  const counterData = [
    { id: 1, value: 20, suffix: "", label: "Years Of Experience" },
    { id: 2, value: 500, suffix: "k", label: "Cases & Queries Solved" },
    { id: 3, value: 5, suffix: "+", label: "Awards Gained" },
    { id: 4, value: 250, suffix: "k+", label: "Happy Clients" },
  ];

  return (
    <div className="counter-4 inner-counter-4 inner-font-1 about-counter">
      <div className="container">
        {/* Heading Section */}
        <div className="row">
          <div className="col-lg-8 m-auto">
            <div className="heading2 white-heading text-center">
              <div className="space80"></div>
              <h2 className="abut-h2">Why Dm2Legal Advisor is the Best?</h2>
            </div>
          </div>
        </div>

        {/* Counters Section */}
        <div className="row counters-3 abtcol">
          {counterData.map((counter) => (
            <div key={counter.id} className="col-md-3  col-6">
              <div className="single-couter-3 text-center">
                <h3>
                  {counter.prefix || ""}
                  <CountUp
                    start={0}
                    end={counter.value}
                    duration={6} // Animation duration in seconds
                    separator=","
                  />
                  {counter.suffix || ""}
                </h3>
                <p>{counter.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="space80"></div>
    </div>
  );
};

export default AboutCounter;
